import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface RefundTransactionDTO {
    [transactionId: string]: number;
}

@Injectable({
    providedIn: 'root'
})
export class RefundService {
    private readonly SERVER_API_URL = environment.serviceUrl;

    constructor(private http: HttpClient) {}

    /**
     * Get transaction IDs and amounts for refunded transactions
     */
    getTransactionIdsForRefund(transactionId: number, isOnline: boolean): Observable<HttpResponse<RefundTransactionDTO>> {
        const url = `${this.SERVER_API_URL}/transactions/transactionids/refund`;
        return this.http
            .get<RefundTransactionDTO>(url, {
                params: { 
                    transactionId: transactionId.toString(),
                    isOnline: isOnline.toString()
                },
                observe: 'response'
            })
            .pipe(map((res: HttpResponse<RefundTransactionDTO>) => res));
    }
}
